/** Only the CLI's literal loopback address and fixed path may receive a session credential. */
export function cliCallback(callback: string | undefined, state: string | undefined): string | null {
	if (!callback || !state || !/^[A-Za-z0-9_-]{43}$/.test(state)) return null
	// Match the original string: URL normalization must not admit integer IPs, userinfo,
	// encoded paths, queries, fragments, or other spellings of localhost.
	const match = /^http:\/\/127\.0\.0\.1:([1-9]\d{3,4})\/token$/.exec(callback)
	if (!match || Number(match[1]) < 1024 || Number(match[1]) > 65535) return null
	return `${callback}?state=${state}`
}
